module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Erstfeld-8aefde4877bfa4cc57ccdfa158cf02fd.svg";